<template>
  <div>
    <div class="headband">
      <div class="container">
        <div class="row">
          <div class="col s6 left-align">
            <img src="/static/img/headband-a.png" alt class="responsive-img">
          </div>
          <div class="col s6 right-align">
            <img src="/static/img/headband-b.png" alt class="responsive-img">
          </div>
        </div>
      </div>
    </div>
    <nav class="navbar deep-orange darken-2" role="navigation"></nav>
    <section class="section-login">
      <div class="section-login-overlay"></div>
      <div class="container">
        <div class="row">
          <div class="col s6 offset-s3 m4">
            <div class="aside-info">
              <img src="/static/img/logoyaracuy.svg" alt class="responsive-img">
            </div>
          </div>
          <div class="col s12 m7 offset-m1">
            <slot/>
          </div>
        </div>
      </div>
    </section>
    <footer class="page-footer grey darken-2">
      <div class="container">
        <div class="row actions">
          <div class="col s12 m6 l3 center-align">
            <router-link :to="{ name: 'login' }" class="btn yellow darken-4 waves-effect">Ingresar</router-link>
            <div
              class="info"
            >Si ya te encuentras registra solo debes ingresar tu información de acceso</div>
          </div>
          <div class="col s12 m6 l3 center-align">
            <router-link :to="{ name: 'register' }" class="btn blue darken-3 waves-effect">Registrarse</router-link>
            <div class="info">Solo necesitas tener un
              <strong>Correo Electrónico</strong> activo para completar el registro.
            </div>
          </div>
          <div class="col s12 m6 l3 center-align">
            <a class="btn blue darken-3 waves-effect">Recupera Contraseña</a>
            <div
              class="info"
            >Si olvidaste la contraseña puede recuperarla haciendo uso de algún dato de contacto aportado durante el registro o actualizado en el perfil.</div>
          </div>
          <div class="col s12 m6 l3 center-align">
            <a class="btn blue darken-3 waves-effect">Reiniciar Registro</a>
            <div
              class="info"
            >Si por Alguna razon olvidaste todos tus datos con los que te registraste y no tienes acceso al
              <strong>Correo Electrónico</strong> puedes reiniciar tu registro.
            </div>
          </div>
        </div>
      </div>
      <div class="footer-copyright grey darken-3">
        <div class="container">
          Gobernación del estado Bolivariano de Yaracuy
          <!--|
          Desarrollado por
          <a class="orange-text text-lighten-3" href="http://materializecss.com">Alfonzo Diez</a>-->
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.card-login {
  background-color: rgba(255, 255, 255, 0.9);
}
.section-login {
  background-image: url("/static/img/background-01.png");
  padding-top: 40px;
  padding-bottom: 30px;
  position: relative;
  background-position: center;
  background-size: cover;
  .section-login-overlay {
    background-color: #000;
    opacity: 0.6;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
}
h3 {
  margin: 0;
  font-size: 1.3em;
  font-weight: 400;
  color: rgba(76, 76, 76, 0.5);
}
.content-input {
  padding-top: 10px;
  padding-bottom: 15px;
}
nav,
nav .nav-wrapper i,
nav a.sidenav-trigger,
nav a.sidenav-trigger i {
  height: 8px;
}
.aside-info {
  position: relative;
}
.actions {
  .info {
    margin-top: 10px;
    margin-bottom: 10px;
    text-align: center;
    font-size: 0.8em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/Public.vue